<h1 class="cg-h1">View and submit precertifications for Medicare Advantage</h1>

<ng-container *ngIf="isPilotMHKUser$ | async; else hsConnectLink">
  <h4 class="cg-h4">{{ 'patient.navinet.header' | translate }}</h4>

  <div [innerHTML]="'patient.navinet.subhead' | translate"></div>

  <p>
    <a
      href="https://www.cigna.com/online-privacy-statement"
      target="_blank"
      rel="noopener noreferrer"
      >Review the Online Privacy Statement<cigna-icon
        type="external-link"
        class="cg-mat-icon-link-right cg-link-color"
      ></cigna-icon
    ></a>
  </p>
</ng-container>
<ng-template #hsConnectLink>
  <p>
    Medicare Advantage precertifications may be submitted through
    <a [href]="hsConnectUrl" target="_blank" rel="noopener noreferrer"
      >HSConnect<cigna-icon
        type="external-link"
        class="cg-mat-icon-link-right cg-link-color"
      ></cigna-icon></a
    >.
  </p>
</ng-template>

<p>Additional precertification tools and resources:</p>
<ul>
  <li>
    For your patients that do not have a Medicare Advantage product, you can
    access more information about
    <a
      target="resourcesWindow"
      [href]="
        '/resourceLibrary/preCertification/preCertification'
          | resourceLink: { secure: true }
          | async
      "
      >how to request precertification</a
    >
  </li>
  <li>
    You can access more information about our
    <a
      target="resourcesWindow"
      [href]="
        '/resourceLibrary/coveragePolicies/index'
          | resourceLink: { secure: true }
          | async
      "
    >
      coverage policies </a
    >in
    <a
      target="resourcesWindow"
      [href]="
        '/resourceLibrary/resourceLibraryMed'
          | resourceLink: { secure: true }
          | async
      "
      >Resources.</a
    >
  </li>
  <li>
    If you don't have the correct entitlement please contact your website access
    manager.
  </li>
</ul>
<ng-container *ngIf="isPilotMHKUser$ | async">
  <div class="cg-button-group cg-margin-top-xl">
    <a
      cignaButton="primary"
      type="button"
      [attr.disabled]="(isImpersonator$ | async) === true ? true : null"
      [href]="mhkUrl"
      target="_blank"
      data-test="btn-accept-privacy"
      rel="noopener noreferrer"
    >
      Accept Privacy Policy and Continue
      <cigna-icon
        type="external-link"
        class="cg-mat-icon-link-right"
      ></cigna-icon>
    </a>
    <button cignaButton="link" type="button" [routerLink]="['/dashboard']">
      Cancel
    </button>
  </div>
</ng-container>
